const TypeInfoObjectEnum = Object.freeze({
    building :  "Building",
    tree:  "Tree",
});
export default TypeInfoObjectEnum